import { Modal } from "@monolith-forensics/monolith-ui";
import { CocIntakeForm, CocIntakeFormValues } from "../Forms";
import {
  FormDescription,
  FormTitle,
} from "@/components/Forms/components/MonolithFormComponents";
import { usePermissions } from "@/hooks/usePermissions";
import { useSnackbar } from "notistack";
import EvidenceCocAPI from "@/api/evidence/coc";

type IntakeCocModalProps = {
  show: boolean;
  onClose: () => void;
  onSubmit: (data?: any) => void;
  evidence_id: number;
};

export const CocIntakeModal = ({
  show,
  onClose,
  onSubmit,
  evidence_id,
}: IntakeCocModalProps) => {
  const { currentUser } = usePermissions();
  const { enqueueSnackbar } = useSnackbar();
  const handleSubmit = async (formData: CocIntakeFormValues) => {
    try {
      const signature = {
        custody_to_sig: formData?.custody_to_sig,
        custody_from_sig: formData?.custody_from_sig,
      };

      const requestData = {
        evidence_id,
        custody_to: formData.custody_to?.location_id || 0,
        custody_from: formData.custody_from,
        coc_intake_timestamp: formData.timestamp,
        location_received: formData.location_received,
        reason: formData.reason || "Evidence Intake",
        coc_type: "Intake",
        signature: JSON.stringify(signature),
        entered_by: currentUser.full_name,
      };

      await EvidenceCocAPI.createIntakeDetails(requestData);

      enqueueSnackbar("Entered Evidence Intake Details", {
        variant: "success",
      });
    } catch (error) {}

    onSubmit?.();
    onClose();
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <Modal open={show} onClose={onClose}>
      <FormTitle style={{ marginBottom: "0px" }}>
        Create Evidence Intake Details
      </FormTitle>
      <FormDescription style={{ marginBottom: "20px" }}>
        Start the chain of custody for this evidence item by enterting the
        intake details.
      </FormDescription>
      <CocIntakeForm onSubmit={handleSubmit} onCancel={handleCancel} />
    </Modal>
  );
};
